/**
 * TanStack Query hooks for `proxy-traffic-real-time-db-block`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	proxyTrafficRealTimeDbBlockQueryKeys,
	type CreateProxyTrafficRealTimeDbBlockBody,
	type ListProxyTrafficRealTimeDbBlockResponse,
	type ProxyTrafficRealTimeDbBlockRow,
} from "./api";

export function useProxyTrafficRealTimeDbBlockList(): UseQueryResult<ListProxyTrafficRealTimeDbBlockResponse, Error> {
	return useQuery({
		queryKey: proxyTrafficRealTimeDbBlockQueryKeys.list(),
		queryFn: list,
	});
}

export function useProxyTrafficRealTimeDbBlockCreate(): UseMutationResult<ProxyTrafficRealTimeDbBlockRow, Error, CreateProxyTrafficRealTimeDbBlockBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: proxyTrafficRealTimeDbBlockQueryKeys.all });
		},
	});
}

export function useProxyTrafficRealTimeDbBlockDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: proxyTrafficRealTimeDbBlockQueryKeys.all });
		},
	});
}
